module.exports = __webpack_public_path__ + "img/guojiabanquanju.e3df4658.png";